import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { AttachmentOwnerType } from '../../../types/Attachment';
import { JsonifiedFile } from '../../../utility/functions';

interface IAttachmentCreateRequest {
  type: AttachmentOwnerType;
  uuid: string;
  files: JsonifiedFile[];
}

const postAttachments = async (requestData: IAttachmentCreateRequest) => {
  const response = await CustomAxios.post(`attachments`, requestData);
  const { data } = response;
  return data;
};

type useCreateAttachmentProps = {
  type: AttachmentOwnerType;
  uuid: string;
  onSuccessCallback: () => void;
};

export function useCreateAttachments({ type, uuid, onSuccessCallback }: useCreateAttachmentProps) {
  return useMutation({
    mutationFn: (files: JsonifiedFile[]) => postAttachments({type, uuid, files}),
    onSuccess: () => {
      // fetch the attachments again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAttachments, type, uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => console.log(err?.response),
  });
}
